import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ImageCollageComponent} from './image-collage.component';

import {DragDropModule} from '@angular/cdk/drag-drop';
import {FileManagerViewModule} from '../../file-manager/file-manager-view/file-manager-view.module';

import {NgxMoveableModule} from 'ngx-moveable';
import {MouseWheelDirective} from './directives/mouse-wheel.directive';

import {MatDialogModule} from '@angular/material/dialog';
import {TextEditorModule} from './text-editor/text-editor.module';
import {DxHtmlEditorModule, DxTabPanelModule} from 'devextreme-angular';
import {CollagePublishComponent} from './collage-publish/collage-publish.component';
import {MatButtonModule} from '@angular/material/button';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatDividerModule} from '@angular/material/divider';
import {MatInputModule} from '@angular/material/input';
import {MatSelectModule} from '@angular/material/select';
import {CollageTemplateModule} from './collage-template/collage-template.module';
import {DrawAfterRenderDirective} from './directives/draw-after-render.directive';
import {GeneralContextModule} from '../../tdo-shared/general-context/general-context.module';
import {CollageBorderModule} from './collage-border/collage-border.module';
import {CollagePagePropertiesModule} from './collage-page-properties/collage-page-properties.module';

//import {ImageUploaderModule} from 'ngx-image-uploader-next';
import {NgxGalleryModule} from '@tdo-inc/ngx-gallery/projects/gallery/src';
//import {MatFileUploadModule} from 'angular-material-fileupload';
import {MatTabsModule} from '@angular/material/tabs';
import {ResizableModule} from 'angular-resizable-element';
import {MatIconModule} from '@angular/material/icon';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {TdoControlsModule} from '../../../tdo-controls/tdo-controls.module';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatCardModule} from '@angular/material/card';
import {MatTooltipModule} from '@angular/material/tooltip';
import {DirectivesModule} from '../../../directives/directives.module';
import {CollagePublishDrawerComponent} from './collage-publish-drawer/collage-publish-drawer.component';
import {TdoDraggableImageComponent} from './collage-image/tdo-draggable-image.component';
//import {FlexModule} from "@angular/flex-layout";
import { CollageNavComponent } from './collage-nav/collage-nav.component';
import { CollageFilterDialogComponent } from './dialogs/collage-filter-dialog/collage-filter-dialog.component';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatRadioModule} from '@angular/material/radio';

@NgModule({
  declarations: [
    ImageCollageComponent,
    MouseWheelDirective,
    DrawAfterRenderDirective,
    CollagePublishComponent,
    CollagePublishDrawerComponent,
    TdoDraggableImageComponent,
    CollageNavComponent,
    CollageFilterDialogComponent
  ],
  imports: [
    DirectivesModule,
    CommonModule,
    DragDropModule,
    FileManagerViewModule,
    TextEditorModule,
    CollageTemplateModule, CollageBorderModule,
    GeneralContextModule, CollagePagePropertiesModule,

    MatDialogModule, MatCheckboxModule, MatSelectModule, MatInputModule,
    MatDividerModule, MatButtonModule, //MatFileUploadModule, 
    MatDatepickerModule,

    NgxMoveableModule,
    DxHtmlEditorModule, DxTabPanelModule,
    //ImageUploaderModule, 
    NgxGalleryModule, MatTabsModule, ResizableModule, MatIconModule, ReactiveFormsModule, TdoControlsModule, FormsModule, MatSidenavModule, MatCardModule, MatTooltipModule, //FlexModule, 
    MatRadioModule,
  ],
  exports: [
    ImageCollageComponent
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class ImageCollageModule {
}
